import { client } from "@/api/client";
import interceptors from "@/api/interceptor";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);


function getHistoryTracking(params) {
	return client.get("public/tracking/get-history-tracking", {
		params: params,
	});
}

function getTrackingKiriminaja(params) {
	return client.get("expka/tracking/get-tracking-trx", {
		params: params,
	});
}

function getTracking(params) {
	return client.get("public/tracking/get-tracking", {
		params: params,
	});
}

function getStatusPesanan(params) {
	return client.get("seller/trx/data-status", {
		params: params,
	});
}
function getSummaryRemainingDebt(params) {
	return client.get("seller/trx/summary_remaining_debt", {
		params: params,
	});
}

function getPesanan(params) {
	return client.get("seller/trx/data", {
		params: params,
	});
}

function getPaidPesanan(params) {
	return client.get("seller/trx/data-paid", {
		params: params,
	});
}

function exportDataTempo(params) {
	return client.get("seller/trx/export_data_tempo", {
		params: params,
	});
}

function getPesananDetail(params) {
	return client.get("seller/trx/detail", {
		params: params,
	});
}
function updatePesananNego(params) {
	return client.post("seller/trx/nego_items", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	}); 
}

function getPesananDetailShipment(params) {
	return client.get("seller/trx/detail-shipment", {
		params: params,
	});
}
function prosesPesanan(params) {
	return client.post("seller/trx/process", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function cancelPesanan(params) {
	return client.post("seller/trx/cancel", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function requestPickupPesanan(params) {
	return client.post("seller/trx/request-pickup-courier", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function kirimPesanan(params) {
	return client.post("seller/trx/deliver", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function paymentStorePaid(params) {
	return client.post("seller/trx/payment-store-paid", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function paymentStoreCancel(params) {
	return client.post("seller/trx/payment-store-cancel", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function pickupStore(params) {
	return client.post("seller/trx/pick-up", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function changeResi(params) {
	return client.post("seller/trx/change-resi", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function getAlamatDetail(params) {
	return client.get("user/address/detail", {
		params: params,
	});
}
function historyUploadTermin(params) {
	return client.get("seller/trx/data-payment", {
		params: params,
	}); 
}
function historyNegoTransaction(params) {
	return client.get("seller/trx/data_history_nego", {
		params: params,
	}); 
}
function excelHistoryNegoTransaction(params) {
	return client.get("seller/trx/export_history_nego", {
		params: params,
	}); 
}
function uploadFinanceSubmit(params) {
	return client.post("seller/trx/finance_submit", params, {
		header: {
			'Content-Type': 'multipart/form-data'
		},
	});
}
function uploadCSSumbit(params) {
	return client.post("seller/trx/cs_submit", params, {
		header: {
			'Content-Type': 'multipart/form-data'
		},
	});
}
export default {
	getStatusPesanan,
	uploadCSSumbit,
	exportDataTempo,
	getSummaryRemainingDebt,
	getPesanan,
	uploadFinanceSubmit,
	historyUploadTermin,
	getPaidPesanan,
	getPesananDetail,
	prosesPesanan,
	kirimPesanan,
	paymentStorePaid,
	paymentStoreCancel,
	pickupStore,
	historyNegoTransaction,
	changeResi,
	getAlamatDetail,
	getTracking,
	getHistoryTracking,
	cancelPesanan,
	requestPickupPesanan,
	getPesananDetailShipment,
	getTrackingKiriminaja,
	excelHistoryNegoTransaction,
	updatePesananNego
};